export const REGISTER_PHONE_FORM_NAME = 'register-phone';
